import { UploadIcon } from '@icons'
import cn from '@integrations/classnames'
import { type ReactNode, useCallback } from '@integrations/react'
import { isValidArray, tr } from 'mmfintech-commons'
import styles from '../FileUploadPane.module.scss'

interface Props {
  caption: ReactNode
  acceptType: string[]
  onUpload?: () => void
  isDisabled?: boolean
}

function UploadComponent({ caption, acceptType, onUpload, isDisabled }: Props) {
  const handleClick = useCallback(() => {
    if (!isDisabled) {
      onUpload?.()
    }
  }, [isDisabled, onUpload])

  return (
    <>
      <div
        className={cn(styles['upload-component-wrapper'], 'upload-component-wrapper', {
          [styles['disabled']]: isDisabled,
          disabled: isDisabled
        })}
        data-test='upload-box'
        onClick={handleClick}
      >
        <UploadIcon />
        <div>
          <span>{caption}</span>
          <span className={cn(styles['or'], 'or')}>{tr('FRONTEND.FILE_UPLOAD.OR_BROWSE', 'or Browse')}</span>
        </div>
      </div>

      {isValidArray(acceptType) && (
        <div className={cn(styles['upload-component-format'], 'upload-component-format')}>
          *File format: *{acceptType.join(', *')}
        </div>
      )}
    </>
  )
}

export default UploadComponent
